import React from 'react'
import { Link } from '@lightspeed/unified-components-helios-theme/react'
import { T } from '@transifex/react'
import { NoteLabelProps } from './useNoteLabelModel'

export const NoteLabel: React.FC<NoteLabelProps> = props => {
  return (
    <span className="uc-base">
      <Link
        customClasses={{ content: ['pl-4', 'typography-body-sm-emphasized'] }}
        onClick={props.onClick}
        customDataAttributes={{
          container: { 'data-track': 'sale-note-link' },
        }}
      >
        <T _str="Note" _context="Note link on sale footer" />
      </Link>
    </span>
  )
}
